export default __webpack_public_path__ + "static/media/notification.53a43ebc.mp3";